import './points-balance-error.scss'

import React from 'react'

import { CloseIconV3 } from '../../../../../../assets/CloseIconV3'
import { DynamicTitle } from '../../../../../../components/common/DynamicTitle'
import { HAS_WINDOW } from '../../../../../../constants'

export const PointsBalanceError = () => {
  const handleClick = () => {
    if (!HAS_WINDOW) {
      return
    }

    window?.location?.reload()
  }

  return (
    <div className="club-card-user-pointsBalance isError">
      <div className="club-card-user-pointsBalance-container">
        <DynamicTitle
          className="pointsBalance-title"
          titleLevel={2}
          title="Seus pontos"
        />
        <div className="pointsBalance-infos-error">
          <div className="pointsBalance-infos-error-message">
            <CloseIconV3 />
            <p className="pointsBalance-infos-error-text">
              Não foi possível atualizar seus pontos agora. Tente novamente em
              instantes.
            </p>
          </div>
          <button
            className="pointsBalance-infos-error-button"
            onClick={handleClick}
          >
            Clique aqui para recarregar a página.
          </button>
        </div>
      </div>
    </div>
  )
}
